import { BorderScale, Color, SpaceScale } from '../../theme/tokens';
import { ResponsiveValue } from '../../theme/types';
import { IconNames } from '../Icon';

export type SizeStyling = Record<
  ButtonSize,
  {
    paddingV: SpaceScale;
    paddingH: SpaceScale;
    fontSize: number;
    lineHeight: string;
  }
>;

export enum ButtonColorVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
  Warning = 'Warning', // To remove for variant `Secondary` and Intent `Danger`
}

export enum ButtonVariant {
  Icon = 'Icon',
  None = 'None',
}

export enum ButtonIntent {
  None = 'None',
  Brand = 'Brand',
  Success = 'Success',
  Danger = 'Danger',
}

export enum ButtonSize {
  Large = 'Large',
  Medium = 'Medium',
}

export type ButtonColorVariantStyles = {
  backgroundColor?: Color;
  color?: Color;
  borderColor?: Color;
  borderWidth?: BorderScale;
  outlineWidth?: BorderScale;
  outlineColor?: Color;
  marginTop?: string;
  marginLeft?: string;
};

export interface AppearanceProps {
  colorVariant?: ButtonColorVariant;
  variant?: ButtonVariant;
  size?: ButtonSize;
  width?: ResponsiveValue<number | string>;
  height?: ResponsiveValue<string | number>;
  maxWidth?: ResponsiveValue<number | string>;
  maxHeight?: ResponsiveValue<string | number>;
}

export interface Props {
  beforeIcon?: IconNames;
  afterIcon?: IconNames;
  icon?: IconNames;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}
